/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// SEARCH

export const SEARCH_PVM = 'SEARCH_PVM';
export const SEARCH_PVM_SUCCESS = 'SEARCH_PVM_SUCCESS';

// PVM======
// GET

export const GET_PVM_SINGLE = 'GET_PVM_SINGLE';
export const GET_PVM_SINGLE_SUCCESS = 'GET_PVM_SINGLE_SUCCESS';

// CREATE

export const CHECK_PVM_NAME = 'CHECK_PVM_NAME';

export const CREATE_PVM = 'CREATE_PVM';
export const CREATE_PVM_SUCCESS = 'CREATE_PVM_SUCCESS';

// EDIT 

export const EDIT_PVM = 'EDIT_PVM';
export const EDIT_PVM_SUCCESS = 'EDIT_PVM_SUCCESS';

// DELETE

export const DELETE_PVM = 'DELETE_PVM';
export const DELETE_PVM_SUCCESS = 'DELETE_PVM_SUCCESS';

// PVM TASK======
// GET

export const GET_PVM_TASKS = 'GET_PVM_TASKS';
export const GET_PVM_TASKS_SLAYER_SUCCESS = 'GET_PVM_TASKS_SLAYER_SUCCESS';
export const GET_PVM_TASKS_BOSS_SUCCESS = 'GET_PVM_TASKS_BOSS_SUCCESS';
export const GET_PVM_TASKS_RAID_SUCCESS = 'GET_PVM_TASKS_RAID_SUCCESS';

export const GET_PVM_TASK_SINGLE = 'GET_PVM_TASK_SINGLE';
export const GET_PVM_TASK_SINGLE_SUCCESS = 'GET_PVM_TASK_SINGLE_SUCCESS';

// CREATE

export const CREATE_PVM_TASK = 'CREATE_PVM_TASK';
export const CREATE_PVM_TASK_SUCCESS = 'CREATE_PVM_TASK_SUCCESS';

// EDIT 

export const EDIT_PVM_TASK = 'EDIT_PVM_TASK';
export const EDIT_PVM_TASK_SUCCESS = 'EDIT_PVM_TASK_SUCCESS';

// DELETE

export const DELETE_PVM_TASK = 'DELETE_PVM_TASK';
export const DELETE_PVM_SLAYER_TASK_SUCCESS = 'DELETE_PVM_SLAYER_TASK_SUCCESS';
export const DELETE_PVM_BOSS_TASK_SUCCESS = 'DELETE_PVM_BOSS_TASK_SUCCESS';
export const DELETE_PVM_RAID_TASK_SUCCESS = 'DELETE_PVM_RAID_TASK_SUCCESS';

export const SET_PVM_TYPE = 'SET_PVM_TYPE';

export const ERROR = 'PVM_ERROR';